var map = {
	"./cs.json": 21529,
	"./da.json": 5280,
	"./de.json": 70972,
	"./en-GB.json": 14722,
	"./en.json": 85992,
	"./es.json": 11375,
	"./fr-CA.json": 89250,
	"./fr.json": 24059,
	"./it.json": 68582,
	"./ja.json": 40774,
	"./ko.json": 69805,
	"./nl.json": 43313,
	"./no.json": 17924,
	"./pl.json": 25987,
	"./pt-BR.json": 90770,
	"./ru.json": 10338,
	"./sv.json": 13170,
	"./zh-Hans.json": 35412,
	"./zh-Hant.json": 81269
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 80556;